import { render } from "./PyramidGoals.vue?vue&type=template&id=02cb9b8d"
import script from "./PyramidGoals.vue?vue&type=script&lang=js"
export * from "./PyramidGoals.vue?vue&type=script&lang=js"
script.render = render

export default script